"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@main/constants");
var steps = {
    direct: {
        etape1: {
            index: 1,
            nb: 1,
            title: 'steps.direct.step1.title',
            pageTitle: 'steps.direct.step1.pageTitle',
            view: 'step1',
            progress: 25,
        },
        etape2: {
            index: 2,
            nb: 2,
            title: 'steps.direct.step2.title',
            pageTitle: 'steps.direct.step2.pageTitle',
            view: 'step2',
            progress: 50,
        },
        etape2_1: {
            index: 3,
            title: '',
            pageTitle: 'steps.direct.step2_1.pageTitle',
            view: 'step2_1',
            progress: 75,
        },
        etape3: {
            index: 4,
            nb: 3,
            title: 'steps.direct.step3.title',
            pageTitle: 'steps.direct.step3.pageTitle',
            view: 'step3',
            progress: 100,
        },
        confirmation: {
            index: 5,
            title: '',
            pageTitle: 'steps.direct.confirmation.pageTitle',
            view: constants_1.CONFIRM_STEP,
        },
    },
    directV3: {
        etape1: {
            index: 1,
            nb: 1,
            title: 'steps.direct.step1.title',
            pageTitle: 'steps.direct.step1.pageTitle',
            view: 'step1',
            progress: 25,
        },
        etape2: {
            index: 2,
            nb: 2,
            title: 'steps.direct.step2.title',
            pageTitle: 'steps.direct.step2.pageTitle',
            view: 'step2',
            progress: 50,
        },
        etape3_1: {
            index: 3,
            nb: 3,
            title: 'steps.direct.step3.title',
            pageTitle: 'steps.direct.step3.pageTitle',
            view: 'step3-1-moncompte-v3',
            progress: 100,
        },
        etape3_2: {
            index: 4,
            title: 'steps.direct.step3.title',
            pageTitle: 'steps.direct.step3.pageTitle',
            view: 'step3-2-moncompte-v3',
            progress: 100,
        },
        confirmation: {
            index: 5,
            title: '',
            pageTitle: 'steps.direct.confirmation.pageTitle',
            view: constants_1.CONFIRM_STEP,
        },
    },
    security: {
        etape1: {
            index: 1,
            nb: 1,
            title: 'steps.security.step1.title',
            pageTitle: 'steps.security.step1.pageTitle',
            view: 'step1-security',
            progress: 25,
        },
        etape2: {
            index: 2,
            nb: 2,
            title: 'steps.security.step2.title',
            pageTitle: 'steps.security.step2.pageTitle',
            view: 'step2',
            progress: 50,
        },
        etape2_1: {
            index: 3,
            title: '',
            pageTitle: 'steps.security.step2_1.pageTitle',
            view: 'step2_1',
            progress: 75,
        },
        etape3: {
            index: 4,
            nb: 3,
            title: 'steps.security.step3.title',
            pageTitle: 'steps.security.step3.pageTitle',
            view: 'step3',
            progress: 100,
        },
        confirmation: {
            index: 5,
            title: '',
            pageTitle: 'steps.security.confirmation.pageTitle',
            view: constants_1.CONFIRM_STEP,
        },
    },
    securityV3: {
        etape1: {
            index: 1,
            nb: 1,
            title: 'steps.direct.step1.title',
            pageTitle: 'steps.direct.step1.pageTitle',
            view: 'step1-security',
            progress: 25,
        },
        etape2: {
            index: 2,
            nb: 2,
            title: 'steps.direct.step2.title',
            pageTitle: 'steps.direct.step2.pageTitle',
            view: 'step2',
            progress: 50,
        },
        etape3_1: {
            index: 3,
            nb: 3,
            title: 'steps.direct.step3.title',
            pageTitle: 'steps.direct.step3.pageTitle',
            view: 'step3-1-moncompte-v3',
            progress: 100,
        },
        etape3_2: {
            index: 4,
            title: 'steps.direct.step3.title',
            pageTitle: 'steps.direct.step3.pageTitle',
            view: 'step3-2-moncompte-v3',
            progress: 100,
        },
        confirmation: {
            index: 5,
            title: '',
            pageTitle: 'steps.direct.confirmation.pageTitle',
            view: constants_1.CONFIRM_STEP,
        },
    },
    purl: {
        etape1: {
            index: 1,
            nb: 1,
            title: 'steps.purl.step1.title',
            pageTitle: 'steps.purl.step1.pageTitle',
            view: 'step1-purl',
            progress: 25,
        },
        etape2: {
            index: 2,
            nb: 2,
            title: 'steps.purl.step2.title',
            pageTitle: 'steps.purl.step2.pageTitle',
            view: 'step2',
            progress: 50,
        },
        etape2_1: {
            index: 3,
            title: '',
            pageTitle: 'steps.purl.step2_1.title',
            view: 'step2_1',
            progress: 75,
        },
        etape3: {
            index: 4,
            nb: 3,
            title: 'steps.purl.step3.title',
            pageTitle: 'steps.purl.step3.pageTitle',
            view: 'step3',
            progress: 100,
        },
        confirmation: {
            index: 5,
            title: '',
            pageTitle: 'steps.purl.confirmation.pageTitle',
            view: constants_1.CONFIRM_STEP,
        },
    },
    purlV3: {
        etape1: {
            index: 1,
            nb: 1,
            title: 'steps.direct.step1.title',
            pageTitle: 'steps.direct.step1.pageTitle',
            view: 'step1-purl',
            progress: 25,
        },
        etape2: {
            index: 2,
            nb: 2,
            title: 'steps.direct.step2.title',
            pageTitle: 'steps.direct.step2.pageTitle',
            view: 'step2',
            progress: 50,
        },
        etape3_1: {
            index: 3,
            nb: 3,
            title: 'steps.direct.step3.title',
            pageTitle: 'steps.direct.step3.pageTitle',
            view: 'step3-1-moncompte-v3',
            progress: 100,
        },
        etape3_2: {
            index: 4,
            title: 'steps.direct.step3.title',
            pageTitle: 'steps.direct.step3.pageTitle',
            view: 'step3-2-moncompte-v3',
            progress: 100,
        },
        confirmation: {
            index: 5,
            title: '',
            pageTitle: 'steps.direct.confirmation.pageTitle',
            view: constants_1.CONFIRM_STEP,
        },
    },
};
exports.default = steps;
